<template>
    <div class="chat_wrap">
        <chat-base chat_roomId='m1' :headerdisplay='true'></chat-base>
    </div>
</template>

<script>
import ChatBase from '@/components/chat/ChatBase.vue';

export default {   
     components:{
        ChatBase
    }
   
}
</script>
<style scoped>
    .chat_wrap{
        height:100vh
    }
</style>
